export default __webpack_public_path__ + "static/media/ybdc_my_pic.e8441676.png";